import { render, staticRenderFns } from "./DevOpsReport.vue?vue&type=template&id=b52f638a&scoped=true"
import script from "./DevOpsReport.vue?vue&type=script&lang=js"
export * from "./DevOpsReport.vue?vue&type=script&lang=js"
import style0 from "./DevOpsReport.vue?vue&type=style&index=0&id=b52f638a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f638a",
  null
  
)

export default component.exports